import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating a view component
import {
    devConfig, // Development configuration settings
    countries, // List of countries for filtering or selection
    profile, // User profile information
    cashDesks, // Cash desk configurations
    agentList, // List of agents for selection or filtering
} from 'config/config'; // Importing configuration constants from the config module

/**
 * Class representing a filter view for cashiers.
 * @extends JetView
 */
export default class FilterCashierView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        // Retrieve the localization service from the app
        const _ = this.app.getService('locale')._;
        // Define the layout for the left section of the UI
        const left = {
            margin: 5, // Set margin for the left section
            id: 'a1', // Unique identifier for the left section
            rows: [
                // Define rows within the left section
                {
                    margin: 15, // Set margin for the row
                    css: 'on-row', // CSS class for styling the row
                    responsive: 'a1', // Responsive identifier for the row
                    cols: [
                        // Define columns within the row
                        {
                            // Column for filtering by user, hidden based on permissions
                            hidden: devConfig.getPermAction('filterByUser', 'Add'),
                            css: 'prm-filterByUser', // CSS class for styling
                            height: 1, // Set height for the column
                        },
                        {
                            // Text input for User ID
                            view: 'text', // Type of UI component
                            name: 'UserId', // Name of the input field
                            type: 'number', // Input type
                            minWidth: 200, // Minimum width of the input
                            // Label with icon and localized text
                            label: "<span class='icon-drivers-license-o'></span>" + _('ID Usuario'),
                            hidden: !devConfig.getPermAction('filterByUser', 'Add'), // Hidden based on permissions
                            css: 'prm-filterByUser', // CSS class for styling
                            labelPosition: 'top', // Position of the label
                            placeholder: _('ID Usuario'), // Placeholder text
                        },
                        {
                            // Text input for Name
                            view: 'text',
                            name: 'Name',
                            minWidth: 200,
                            label: "<span class='icon-user'></span>" + _('Nombre'),
                            labelPosition: 'top',
                            placeholder: _('Nombre'),
                            hidden: !devConfig.getPermAction('filterByUser', 'Add'), // Hidden based on permissions
                            css: 'prm-filterByUser', // CSS class for styling
                        },
                        {
                            // Text input for Login
                            view: 'text',
                            name: 'Login',
                            minWidth: 200,
                            label: _('Login'),
                            labelPosition: 'top',
                            placeholder: _('Login'),
                            hidden: !devConfig.getPermAction('filterByUser', 'Add'), // Hidden based on permissions
                            css: 'prm-filterByUser', // CSS class for styling
                        },
                        {
                            // Rich select for country selection
                            view: 'richselect',
                            name: 'CountrySelect',
                            id: 'CountrySelect', // Unique identifier for the select
                            localId: 'regions:combo', // Local identifier for the component
                            minWidth: 200,
                            label: "<span class='icon-language'></span>" + _('País'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            options: {
                                body: {
                                    // Template for displaying country options
                                    template: function (obj) {
                                        return "<i class='flags " + obj.icon + "'></i>" + obj.value;
                                    },
                                    data: countries, // Data source for the options
                                },
                            },
                            hidden: devConfig.getCountryReport() || !devConfig.getPermAction('filterByCountry', 'Add'), // Hidden based on permissions and report settings
                            css: 'prm-filterByCountry', // CSS class for styling
                        },
                        {
                            // Read-only rich select for country selection
                            view: 'richselect',
                            name: 'CountrySelect2',
                            localId: 'regions:combo', // Local identifier for the component
                            minWidth: 200,
                            label: "<span class='icon-language'></span>" + _('País'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            value: profile.Settings.ReportCountry, // Default value from profile settings
                            readonly: true, // Set as read-only
                            options: {
                                body: {
                                    // Template for displaying country options
                                    template: function (obj) {
                                        return "<i class='flags " + obj.icon + "'></i>" + obj.value;
                                    },
                                    data: countries, // Data source for the options
                                },
                            },
                            hidden: !devConfig.getCountryReport() || !devConfig.getPermAction('filterByCountry', 'Add'), // Hidden based on permissions and report settings
                            css: 'prm-filterByCountry', // CSS class for styling
                        },
                    ],
                },
                {
                    margin: 15, // Set margin for the row
                    css: 'on-row', // CSS class for styling the row
                    responsive: 'a1', // Responsive identifier for the row
                    cols: [
                        // Define columns within the row
                        {
                            // Combo box for selecting Bet Shop
                            view: 'combo',
                            name: 'BetShopId',
                            label: "<span class='icon-shop'></span>" + _('Punto de Venta'),
                            hidden: !devConfig.getPermAction('filterByBetShop', 'Add'), // Hidden based on permissions
                            css: 'prm-filterByBetShop', // CSS class for styling
                            labelPosition: 'top', // Position of the label
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            id: 'BetShopId', // Unique identifier for the combo
                            options: {
                                body: {
                                    // Function to fetch data for the combo box
                                    dataFeed: function (text) {
                                        var vthis = this; // Reference to the current context
                                        if (text.length > 2) {
                                            // Trigger data fetch if input length exceeds 2
                                            webix
                                                .ajax() // AJAX request to fetch data
                                                .headers({
                                                    'Content-type': 'application/json', // Set content type
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'es/Select/BetShopsSelect', // API endpoint
                                                    '{"Filter":"' + text + '"}', // Request payload
                                                    {
                                                        error: function (text, data, XmlHttpRequest) {
                                                            webix.message(
                                                                'Error! ', // Display error message
                                                            );
                                                        },
                                                        success: function (text, data, XmlHttpRequest) {
                                                            var resp = JSON.parse(
                                                                text, // Parse the response
                                                            );
                                                            if (
                                                                !resp.HasError // Check for errors in the response
                                                            ) {
                                                                vthis.parse(
                                                                    resp.Data, // Populate the combo with data
                                                                );
                                                            }
                                                        },
                                                    },
                                                );
                                        }
                                    },
                                },
                            },
                        },
                        { id: 'grav2', gravity: 3 }, // Gravity setting for layout
                    ],
                },
            ],
        };
        // Define the upper section configuration for the layout
        const upper_section = {
            css: 'father-container', // CSS class for styling the container
            cols: [left], // Columns to be included in the upper section
        };

        // Define the buttons configuration
        const buttons = {
            id: 'b2', // Unique identifier for the button group
            height: 100, // Height of the button group
            rows: [
                {
                    margin: 10, // Margin around the row
                    responsive: 'b2', // Responsive design identifier
                    cols: [
                        { id: 'grav', gravity: 4 }, // Column with gravity for layout positioning
                        {
                            view: 'button', // Button component
                            value: _('Limpiar'), // Button label, translated using the _ function
                            width: screen == 'small' ? 0 : 100, // Conditional width based on screen size
                            minWidth: 200, // Minimum width of the button
                            click: () => {
                                // Click event handler for the button
                                this.getRoot().clear(); // Clear the root component
                            },
                        },
                        {
                            view: 'button', // Button component
                            value: _('Consultar'), // Button label, translated using the _ function
                            hotkey: 'enter', // Hotkey to trigger the button
                            type: 'form', // Type of button, indicating it submits a form
                            width: screen == 'small' ? 0 : 100, // Conditional width based on screen size
                            minWidth: 200, // Minimum width of the button
                            click: () => {
                                // Click event handler for the button
                                const filterdata = this.getRoot().getValues(); // Retrieve values from the root component
                                if (devConfig.getCountryReport()) {
                                    // Check if country report is enabled
                                    filterdata.CountrySelect = profile.Settings.ReportCountry; // Set country filter
                                }
                                delete filterdata['CountrySelect2']; // Remove unnecessary filter data
                                this.app.callEvent('cashier:filter', [
                                    // Trigger filter event with the collected data
                                    filterdata,
                                ]);
                                $$('b5').collapse(); // Collapse the specified component
                                $$('a5').scrollTo(100, 0); // Scroll to a specific position in the specified component
                            },
                        },
                    ],
                },
            ],
        };
        const buttons2 = {
            /**
             * Padding for button layout.
             * @type {number}
             */
            padding: 10,

            /**
             * Array of button configurations.
             * @type {Array<Object>}
             */
            cols: [
                {
                    /**
                     * Button for adding a point.
                     * @type {string}
                     */
                    view: 'button',
                    value: _('Añadir Punto'), // Localized button label
                    type: 'form', // Indicates this button submits the form
                    hidden: !devConfig.getPermAction('betShopAdd', 'Add'), // Visibility based on permissions
                    css: 'prm-betShopAdd', // CSS class for styling
                    click: () => {
                        $$('filterPopup').hide(); // Hides the filter popup
                        // Checks the current page and shows the appropriate view
                        if (this.getUrl()[0].page !== 'betShopManagement')
                            this.show('addBetShopManagement/betShopManagement.addInformationBetShop');
                        else this.show('/betShopManagement.addinformationBetShop');
                    },
                },
                {
                    /**
                     * Button for clearing the form.
                     * @type {string}
                     */
                    view: 'button',
                    value: _('Limpiar'), // Localized button label
                    click: () => {
                        $$('myForm2').clear(); // Clears the form fields
                    },
                },
                {
                    /**
                     * Button for consulting/filtering data.
                     * @type {string}
                     */
                    view: 'button',
                    value: _('Consultar'), // Localized button label
                    hotkey: 'enter', // Shortcut key for the button
                    type: 'form', // Indicates this button submits the form
                    click: () => {
                        const filterdata = $$('myForm2').getValues(); // Retrieves form values
                        // Checks if country report is enabled and sets the country filter
                        if (devConfig.getCountryReport()) {
                            filterdata.CountrySelect = profile.Settings.ReportCountry;
                        }
                        delete filterdata['CountrySelect2']; // Removes unnecessary filter
                        this.app.callEvent('betShop:filter', [filterdata]); // Triggers filter event with data
                    },
                },
            ],
        };
        // Define an accordion section configuration object
        const accordion_section = {
            // Specifies the type of the section
            type: 'wide',
            // Contains an array of rows within the accordion
            rows: [
                {
                    // Allows multiple items to be expanded simultaneously
                    multi: true,
                    // Defines the view type as an accordion
                    view: 'accordion',
                    // CSS class for styling the accordion
                    css: 'betShop',
                    // Indicates whether the accordion is initially collapsed
                    collapsed: true,
                    // Specifies the type of the accordion
                    type: 'clean',
                    // Contains nested rows within the accordion
                    rows: [
                        {
                            // Header text for the accordion section
                            header: _('Filtros'),
                            // Unique identifier for the section
                            id: 'b5',
                            // Body configuration for the section
                            body: {
                                // Padding around the body content
                                padding: 10,
                                // Rows contained within the body
                                rows: [upper_section, buttons],
                            },
                        },
                    ],
                },
            ],
        };

        // Define a scrollable section configuration object
        const accordion_section3 = {
            // Specifies the view type as a scrollable view
            view: 'scrollview',
            // Enables scrolling in both x and y directions
            scroll: 'xy',
            // Body configuration for the scrollable section
            body: {
                // Padding around the body content
                padding: 10,
                // Rows contained within the body
                rows: [upper_section],
            },
        };
        /**
         * Creates a filter popup window using Webix UI.
         *
         * @type {webix.ui.window}
         */
        const filterPopup = webix.ui({
            view: 'window', // Defines the type of UI component as a window
            move: true, // Allows the window to be moved by the user
            id: 'filterPopup', // Unique identifier for the popup window
            fullscreen: true, // Sets the window to fullscreen mode
            head: {
                // Header configuration of the window
                view: 'toolbar', // Defines the header as a toolbar
                cols: [
                    // Columns within the toolbar
                    { view: 'label', label: _('Filtros'), align: 'center' }, // Label for the filter section
                    {
                        view: 'icon', // Icon button for closing the window
                        icon: 'wxi-close', // Icon type for closing action
                        click: function () {
                            // Click event handler for the icon
                            this.getTopParentView().hide(); // Hides the popup window when clicked
                        },
                    },
                ],
            },
            modal: true, // Makes the window modal, preventing interaction with other UI elements
            position: 'center', // Centers the window on the screen
            body: {
                // Body configuration of the window
                view: 'form', // Defines the body as a form
                id: 'myForm2', // Unique identifier for the form
                type: 'clean', // Sets the form type to clean (no default styling)
                rows: [accordion_section3, buttons2], // Rows within the form, containing accordion and buttons
                rules: {
                    // Validation rules for the form fields
                    fname: webix.rules.isNotEmpty, // Ensures the 'fname' field is not empty
                },
            },
        });
        /**
         * Returns a configuration object for a Webix form.
         * @returns {Object} The form configuration object.
         */
        return {
            /**
             * Unique identifier for the form.
             * @type {string}
             */
            id: 'filter',

            /**
             * Specifies the type of view.
             * @type {string}
             */
            view: 'form',

            /**
             * Defines the form type as clean.
             * @type {string}
             */
            type: 'clean',

            /**
             * Array of rows to be displayed in the form.
             * @type {Array}
             */
            rows: [
                /**
                 * Conditional rendering of the accordion section or a spacer based on screen dimensions.
                 * @type {Object}
                 */
                screen.width > 500 && screen.height > 500
                    ? accordion_section
                    : { id: 'right2', height: 1, width: screen.width - 54 },
            ],

            /**
             * Validation rules for the form fields.
             * @type {Object}
             */
            rules: {
                /**
                 * Rule to ensure the 'fname' field is not empty.
                 * @type {Function}
                 */
                fname: webix.rules.isNotEmpty,
            },
        }; // Placeholder for the view's configuration content
    }

    /**
     * Initializes the view and its components.
     * @param {Object} grid - The grid component to be initialized.
     */
    init(grid) {
        /**
         * Executes a function when the Webix library is fully loaded and ready.
         * This is a callback function that ensures that the DOM and Webix components
         * are available for manipulation.
         */
        webix.ready(function () {}); // Placeholder for the initialization content of the view
    }
}

// FILE DOCUMENTED
